import React, { useState, useEffect } from "react"
import DashboardNavbar from "../../components/Navbar/DashboardNavbar"
import useFetch from "../../hooks/useFetch"
import {
  addProductToRegistry,
  deleteProductFromRegistry,
  getPersonalRegistries,
  getRegistryById
} from "../../utils/ApiRequests"
import DashboardItems from "../../components/DashboardComponents/DashboardItems"
import FullLoader from "../../components/Loaders/FullLoader"
import { useToasts } from "react-toast-notifications"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import { useHistory } from "react-router-dom"

const Checklist = () => {
  const [showFilter, setShowFilter] = useState(false)
  const { response, loading: apiLoad } = useFetch(getPersonalRegistries)
  const [selectedRegistry, setSelectedRegistry] = useState(
    localStorage.getItem("registry") || ""
  )
  const [loading, setLoading] = useState(false)
  const [registryProducts, setRegistryProducts] = useState([])
  const { addToast } = useToasts()
  const history = useHistory()

  // Local storage state hack
  useEffect(() => {
    const parsedRegistry = localStorage.getItem("registry") || ""
    setSelectedRegistry(parsedRegistry)
  }, [])

  useEffect(() => {
    localStorage.setItem("registry", selectedRegistry)
  }, [selectedRegistry])
  // End of local storage state hack \\

  const { response: regRes, loading: regLoad } = useFetch(
    getRegistryById,
    selectedRegistry
  )

  console.log(regRes)

  useEffect(() => {
    setRegistryProducts(regRes?.data?.products)
  }, [regRes])

  const addItemToRegistry = data => {
    setLoading(true)
    // setDeleting(true)

    addProductToRegistry(selectedRegistry, data)
      .then(res => {
        setLoading(false)
        // setDeleting(false)
        addToast(res.data?.message, {
          appearance: "success",
          autoDismiss: true
        })
        history.go(0)
      })
      .catch(err => {
        setLoading(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  const DeleteProduct = id => {
    setLoading(true)
    // setDeleting(true)
    deleteProductFromRegistry(selectedRegistry, id)
      .then(res => {
        setLoading(false)
        // setDeleting(false)
        addToast(res.data.message, {
          appearance: "success",
          autoDismiss: true
        })
        history.go(0)
      })
      .catch(err => {
        setLoading(false)
        // setDeleting(false)
        addToast(getApiErrorMessage(err.response), {
          appearance: "error",
          autoDismiss: true
        })
      })
  }

  return (
    <div>
      <DashboardNavbar />
      {(loading || apiLoad || regLoad) && <FullLoader />}
      <div className="global-container mobiles:relative mobiles:z-10 pt-10 mt-24">
        <h5 className="font-semibold text-2xl">Checklist</h5>
        <div className="flex gap-10 items-center mt-3">
          <p className="text-gray-600">Add custom gifts to your registry</p>

          <select
            className="p-2 focus:outline-none bg-white cursor-pointer"
            onChange={e => setSelectedRegistry(e.target.value)}
            value={selectedRegistry}
          >
            <option>Select a registry</option>
            {response &&
              response?.data.map((r, i) => (
                <option key={i} value={r._id}>
                  {r.name}
                </option>
              ))}
          </select>
        </div>

        {selectedRegistry && (
          <DashboardItems
            products={registryProducts || []}
            deleteProduct={DeleteProduct}
            addProduct={addItemToRegistry}
            registryId={selectedRegistry}
            contributions={regRes?.data?.contributions}
          />
        )}
      </div>
    </div>
  )
}

export default Checklist
